import countryList from '../localization/countryList.ru';

const COUNTRY_TYPE_LIST = Object.keys(countryList);
const FORMER_NAME_TYPE_LIST = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
const ID_TYPE_LIST = ["1", "2", "3", "4", "5", "6"];
const CITIZENSHIP_TYPE_LIST = Object.keys(countryList);
const MAIN_DOCUMENT_TYPE_LIST = ['3', '6', '15', '16', '17'];
const EMPLOYMENT_TYPE_LIST = ['1', '11', '3', '4', '5', '6', '7', '8', '9', '10'];
const SCOPE_OF_EMPLOYMENT_TYPE_LIST = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'];
const POST_TYPE_LIST = ['1', '2', '3', '4', '5', '6', '7', '8'];
const EDUCATION_TYPE_LIST = ['1', '2', '3', '4', '5'];
const FAMILY_STATUS_TYPE_LIST = ['1', '2'];

export default {
    COUNTRY_TYPE_LIST,
    FORMER_NAME_TYPE_LIST,
    ID_TYPE_LIST,
    CITIZENSHIP_TYPE_LIST,
    MAIN_DOCUMENT_TYPE_LIST,
    EMPLOYMENT_TYPE_LIST,
    SCOPE_OF_EMPLOYMENT_TYPE_LIST,
    POST_TYPE_LIST,
    EDUCATION_TYPE_LIST,
    FAMILY_STATUS_TYPE_LIST
}